var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.4 25.3c0-.6.2-3.8 1.8-4.4s3.3 2 6.7 3.7 4.7.5 11.8.9a112 112 0 0 1 13.8 1.9c6.3 1.1 7.1 1 8.5.6s2.9-.9 3.9-.1S73 30.8 73 31c-.2 2.6-2.3 4.4-5.3 6.9s-2.1 1.5-3.8 3-2.3 2.7-4.2 4.7c-3.6 3.6-4.8 2.8-6.2 5.3a11.7 11.7 0 0 0-1.5 6.3c.2 2 1 3.1.5 3.6s-3.3 0-4.1-1.6 2-4.1 1.2-6.5-2.8-1.5-5.6-4.4-1.5-2.5-3.1-4.4-4.2-2.7-6.4-4.6-9.3-7.9-9.1-14ZM53.2 70.9a2.8 2.8 0 0 1-3.8.8c-1.7-1.4 0-7 1.6-7.1s3.6 4.4 2.2 6.3ZM23.8 89.9a15.7 15.7 0 0 1-.2-5.5c.3-2.6.6-5.1 2.1-5.9s5.4 4 11.6 4.8c4.1.4 4.3-1.7 10.1-2.5 7.9-1 9.1 2.6 15.9 1.4s9.9-5.1 12.2-3.4 1 1.7 1.4 3.6a15.2 15.2 0 0 1-.3 7.6H63.4l-14.7-.2H23.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.5 9.3a30.8 30.8 0 0 0-.4 15.9C26.9 40 41 42.5 40.5 51.6S26.6 64.4 23.6 75.9a35 35 0 0 0-1.1 9.5 32 32 0 0 0 1 7.3l-1.7.4a34.5 34.5 0 0 1 .1-18.1c3.8-13.2 14.2-14.9 14.3-23.8S25 39.9 21 25.9a35.7 35.7 0 0 1-.4-16.8ZM76.7 9.2a30.8 30.8 0 0 1 .4 15.9c-3.8 14.8-17.9 17.3-17.4 26.4S72.2 62 76.6 75.8a32.4 32.4 0 0 1 .4 17.4h2.2a37.8 37.8 0 0 0-.9-18.3c-4.3-13.5-14.6-15.2-14.7-24s11.6-11.1 15.6-25.1A33.3 33.3 0 0 0 79.6 9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.7 99.8c.2-1.1 1.1-5.8 4.9-8.1l2.2-.9h66.3a10.2 10.2 0 0 1 2.2.9c3.9 2.3 4.8 7.1 5 8.3H49.8ZM82.9 9.8H17.2a14.5 14.5 0 0 1-2.4-1c-3.7-2.5-3.9-7.6-3.9-8.3A1795 1795 0 0 1 89 .4c0 .6 0 5.9-3.8 8.4a10.4 10.4 0 0 1-2.3 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3e9b119ea7aea574bfaa89f2b1582e24.svg";
export { ForwardRef as ReactComponent };